var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationStreetfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 170,
    viewBox: "0 0 200 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5789_15038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1104 12.1899C66.7204 13.2799 69.1503 15.5599 69.2003 18.3799C69.2503 21.2399 66.9304 23.5299 65.9804 26.2299C64.7504 29.7099 66.0803 33.9299 69.0903 36.0599",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1789 23.04C58.0189 25.95 57.1989 28.99 56.7489 32.09C56.4789 33.94 56.4289 36.05 57.7189 37.41C58.7589 38.5 60.3689 38.76 61.8089 39.23C65.4389 40.4 68.4689 43.3 69.7989 46.88C71.1289 50.46 70.7389 54.63 68.7589 57.89",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9399 40.7397C81.4499 39.9797 69.7999 40.6497 58.8899 44.1897C50.3899 46.9497 36.1799 53.2097 33.0599 62.4997C31.7599 66.3597 36.7399 84.7597 38.2399 90.4897C43.2899 109.78 51.1799 128.18 56.9999 147.23C59.4899 155.37 63.0899 155.21 70.8999 154.02C81.1599 152.45 91.3799 150.6 101.55 148.51C105.19 147.77 107.86 147.02 110.58 144.47C111.25 143.84 111.93 143.19 112.37 142.39C112.8 141.6 112.97 140.7 113.07 139.81C113.52 135.83 113.05 131.54 112.82 127.55C112.59 123.56 112.77 119.2 112.84 115.01C112.99 106.01 112.94 96.9897 112.47 87.9997C112.02 79.3297 111.19 70.6697 109.79 62.0997C108.8 56.0997 108.6 46.9297 103 43.1697C102.04 42.5297 93.1599 40.4197 93.2299 40.7697C93.1399 40.7697 93.0499 40.7597 92.9599 40.7497L92.9399 40.7397Z",
    fill: "#00BCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9701 93.8999C81.4901 85.0499 85.1401 76.3699 90.5301 70.0399C95.9201 63.7099 102.9 59.4999 110.06 56.2399C117.35 52.9199 124.95 50.4899 132.68 49.0199C142.16 47.2099 152.99 47.2699 160.01 54.8299C164.04 59.1699 166.64 65.3699 167.87 71.5599C170.57 97.5399 149.14 90.4099 136.52 90.9799C131.97 91.1899 81.9601 93.8099 81.9701 93.8999Z",
    fill: "#C27050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6406 64.8597C33.8006 83.5097 42.8306 100.65 47.5306 118.73C50.2906 129.35 52.9206 142.71 58.8706 151.94C59.4806 152.88 60.1606 153.82 61.1406 154.36C62.4106 155.05 67.8206 154.73 69.2606 154.63C94.5406 152.86 114.321 143.82 113.061 139.81C111.811 135.8 88.0606 135.95 76.3106 138.19C71.1506 139.18 65.7406 140.45 61.8206 143.96C58.2706 147.13 59.7506 149.82 62.0806 151.71C62.8006 152.3 63.7406 152.62 64.6806 152.68C80.3106 153.62 105.541 142.71 110.561 138.89C113.561 136.6 114.761 133.3 114.771 129.32C114.801 114.42 81.9306 108.19 81.9306 92.2497C81.9306 70.9597 100.901 61.5597 105.161 59.0397C111.191 55.4697 125.081 49.8597 132.691 49.0097C141.471 48.0297 150.871 48.0097 157.201 52.3197C162.301 55.7797 168.011 64.9697 168.011 74.1497C168.011 80.3097 167.741 84.5397 164.601 87.0397C160.991 89.9197 159.091 92.6697 154.371 90.2097C149.651 87.7497 145.101 91.5297 139.811 91.0897C134.521 90.6497 131.311 87.0397 126.291 88.9897C121.271 90.9397 119.211 95.8097 112.741 94.7697",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2997 113.27C81.9797 119.72 87.6297 126.78 94.0597 128.57C100.49 130.36 107.27 128.56 113.82 127.3C121 125.92 128.29 125.2 135.59 125.15C141.99 125.1 148.57 125.54 154.62 123.38C160.67 121.22 165.84 116.85 165.83 104.23",
    fill: "#C27050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7308 98.7102C78.4708 99.8402 73.6508 102.66 72.1608 106.49C70.6608 110.33 73.3408 115.03 78.5608 116.26C86.2308 118.07 93.6408 112.28 101.701 112.41C106.801 112.49 111.541 114.96 116.611 114.55C119.931 114.28 122.811 112.82 125.831 111.79C136.431 108.17 148.801 109.81 160.501 109.46C165.731 109.3 171.271 108.63 175.181 106.1C179.091 103.57 180.461 98.6802 176.791 95.9602C173.781 93.7402 168.911 93.7902 164.631 93.9902C138.221 95.2302 111.811 96.4702 85.4008 97.7102",
    fill: "#C0FFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46 61.1999V60.4399",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52 69.9499V69.1899",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2305 87.49V86.73",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5297 89.8699C80.1497 89.0699 76.8897 95.7799 75.4897 99.6199C74.0897 103.46 76.5997 108.16 81.4897 109.39C88.6797 111.2 95.6297 105.41 103.18 105.54C107.96 105.62 112.4 108.09 117.15 107.68C120.27 107.41 122.96 105.95 125.8 104.92C135.73 101.3 147.33 102.94 158.3 102.59C163.2 102.43 168.39 101.76 172.06 99.2299C175.73 96.6999 180.39 91.5299 175.97 87.0299C173.45 84.4699 164.52 82.7599 160.71 84.0499C139.82 91.0899 142.65 81.0199 127.13 84.9399C114.8 88.0499 117.5 93.7499 86.5397 89.8799L86.5297 89.8699Z",
    fill: "#F7DADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.04 76.0801V75.3201",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.989 75.7002V74.9402",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.92 83.9802V83.2202",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.601 68.2302V67.4702",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.69 49.0097C141.47 48.0297 150.87 48.0097 157.2 52.3197C162.3 55.7797 168.01 64.9697 168.01 74.1497C168.01 80.3097 167.74 84.5397 164.6 87.0397C160.99 89.9197 159.09 92.6697 154.37 90.2097C149.65 87.7497 145.1 91.5297 139.81 91.0897C134.52 90.6497 131.31 87.0397 126.29 88.9897C121.27 90.9397 119.16 96.0697 112.74 94.7697C101.89 92.5697 77.3305 81.9197 75.4905 99.6197C74.7205 107.04 79.2605 111.34 85.4105 109.82C91.5605 108.3 91.3305 103.6 89.6105 102.46C87.8905 101.32 85.4905 104 84.9205 106.55C84.3505 109.1 81.8305 119.29 87.3905 124.49",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6406 64.8604C33.8006 83.5104 42.8306 100.65 47.5306 118.73C50.2906 129.35 52.9206 142.71 58.8706 151.94C59.4806 152.88 60.1606 153.82 61.1406 154.36C62.4106 155.05 67.8206 154.73 69.2606 154.63C94.5406 152.86 114.321 143.82 113.061 139.81C111.811 135.8 88.0606 135.95 76.3106 138.19C71.1506 139.18 65.7406 140.45 61.8206 143.96C58.2706 147.13 59.7506 149.82 62.0806 151.71C62.8006 152.3 63.7406 152.62 64.6806 152.68C80.3106 153.62 105.541 142.71 110.561 138.89C113.561 136.6 114.761 133.3 114.771 129.32",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.84 84.04C168.52 84.18 170.18 84.49 171.79 84.95C173.74 85.5 175.73 86.37 176.85 88.06C178.35 90.31 177.8 93.48 176.18 95.65C174.56 97.82 172.09 99.18 169.61 100.27C164.47 102.54 158.37 103.9 153.36 101.36C152.37 100.86 151.4 100.2 150.29 100.15C149.54 100.12 148.8 100.38 148.1 100.66C143.72 102.43 139.26 105.36 134.67 104.25C132.35 103.69 130.22 102.11 127.83 102.26C125.42 102.41 123.53 104.26 121.58 105.68C119.63 107.1 116.83 108.13 114.91 106.66",
    stroke: "#172057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5789_15038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 170,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationStreetfood);
export default __webpack_public_path__ + "static/media/illustration-streetfood.a327b5856c7f03f35a5b34d90b824243.svg";
export { ForwardRef as ReactComponent };